import { useAppDispatch, useAppSelector } from '@/app/hooks';
import {
  isSidebarMinimizedSelector,
  toggleSidebar,
} from '@/features/ui/uiSlice';

type UseUiReturnType = [boolean, () => void];

const useUi = (): UseUiReturnType => {
  const isSidebarMinimized = useAppSelector(isSidebarMinimizedSelector);
  const dispatch = useAppDispatch();
  const handleToggle = () => dispatch(toggleSidebar());
  return [isSidebarMinimized, handleToggle];
};

export default useUi;
